import $ from 'jquery';

var $slider = $('.content-slider__slides');

$slider.each(function () {
    $(this).slick({
        infinite: true,
        arrows: true,
        dots: false,
        draggable: true,
        prevArrow: '<a href="#" aria-label="Vorheriger Slide" class="slick-prev fa-thin fa-chevron-left"></a>',
        nextArrow: '<a href="#" aria-label="Nächster Slide" class="slick-next fa-thin fa-chevron-right"></a>',
        appendArrows: $('<div>').addClass('absolute-container arrow-container').insertAfter($(this)),
    });
})
